// 共通模块:  刷新后能保持当前选中页面。

// hongmj: 这里放全局参数
const state = {
    pageInfo: [
        {
            module: 'module_XXXX', // 哪个模块
            page: 1 // 当前分页是第几页
        }
    ]
}

// hongmj: 这里是set方法
const mutations = {
    // 保存 某个模块 选中的分页
    SAVE_PAGE: (state, pageCache) => {
        let findFlag = false // false: 没找到匹配，true: 找到匹配。
        state.pageInfo.forEach((item) => {
            if (pageCache.module === item.module) { // 找到匹配，表示已经注册.
                item.page = pageCache.page // 直接更新page.
                findFlag = true // 找到匹配
            }
        })

        if (!findFlag) { // 没找到匹配，需要追加
            state.pageInfo.push(pageCache)
        }
    }

}

// hongmj: 这部分暂时用不上
const actions = {
}

// hongmj: 下面不清楚做啥的，好像都有?
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
